/**
 * Global scroll listener that adds/removes `.is-scrolling` class on any
 * scrollable element. Paired with global CSS in index.css to show/hide
 * native scrollbar thumbs with a macOS-style fade behavior.
 */
export function setupAutoHideScrollbars() {
  const timeouts = new WeakMap()

  const handleScroll = (e) => {
    const el = e.target
    if (!(el instanceof HTMLElement)) return

    el.classList.add('is-scrolling')

    const existing = timeouts.get(el)
    if (existing) clearTimeout(existing)

    timeouts.set(el, setTimeout(() => {
      el.classList.remove('is-scrolling')
      timeouts.delete(el)
    }, 800))
  }

  document.addEventListener('scroll', handleScroll, { capture: true, passive: true })
}
